<script setup lang="ts">
import { useMediaUrl } from "@/composables"
import { calculateStyle } from "../../CmsPage/configuration"
import FrontendFragment from "../FrontendFragment.vue"

const props = defineProps<{
    element: any
}>()

const { mediaUrl } = useMediaUrl()
</script>

<template>
    <section class="cms-picture-text" :class="{ 'flex-row-reverse': props.element.config.pictureTextLayout === '1' }">
        <div class="cms-picture-text-picture">
            <img
                alt=""
                class="img-fluid"
                :src="mediaUrl(props.element.fileName)"
                :style="calculateStyle(props.element)"
            />
        </div>

        <div class="cms-picture-text-text">
            <FrontendFragment v-bind="{ elements: props.element.columns[0] }"></FrontendFragment>
        </div>
    </section>
</template>
